import platform from 'platform'
import {DeepWritable} from 'ts-essentials'
import {Storage} from '@client/storage'
import {Tracking} from '@common/tracking'
import {getSizeInRange, getTextRightPanelWidth} from '@common/tracking-utils'
import {boardViewStore} from '@components/board-view/board-view-store'
import {rightPanelStore} from '@components/right-panel/right-panel/right-panel-store'
import {
  AppState,
  BoardViewState,
  ChatPanelState,
  TaskChatState,
  TimelineState
} from './app-persistence-types'

export class AppPersistence {
  static init(): void {
    const appState = this.load()
    rightPanelStore.init(appState)
    boardViewStore.init(appState)
  }

  private static load(): AppState | undefined {
    const serialized = Storage.getItem('state')
    if (!serialized) {
      return undefined
    }

    const res = JSON.parse(serialized) as DeepWritable<AppState>
    if (res.chatPanel) {
      res.chatPanel.groupChatEdit = false
    }
    if (res.chatFilter && typeof res.chatFilter.groupChats === 'undefined') {
      res.chatFilter.groupChats = true
    }

    const panelWidth = res?.chatPanel?.width || 0

    // нужен таймаут для инициализации amplitude
    setTimeout(() => {
      void Tracking.sendUserProperty(
        {
          rightPanelWidth: getTextRightPanelWidth(panelWidth)
        },
        true
      )

      void Tracking.sendUserProperty({
        screenHeight: getSizeInRange(window.document.body.clientHeight),
        screenWidth: getSizeInRange(window.document.body.clientWidth, 200),
        browser: platform.name,
        web_os: platform.os?.family
      })
    }, 30_000)

    return res
  }

  static save(): void {
    const chatFilter = rightPanelStore.state.chatFilter
    const chatPanel: ChatPanelState = rightPanelStore.state.chatPanel
    const taskChat: TaskChatState = {tab: rightPanelStore.currentTab}
    const boardView: BoardViewState = {view: boardViewStore.state.view}
    const timeline: TimelineState = {zoom: boardViewStore.state.zoom}

    const appState: Partial<AppState> = {
      chatFilter,
      chatPanel,
      taskChat,
      boardView,
      timeline
    }

    Storage.setItem('state', JSON.stringify(appState))
  }
}
